import { wget } from 'lodash';

function getEnumsFromState(state) {
  return wget(state, 'session.enums', {});
}

export default getEnumsFromState;
